import actionTypes from 'Redux/constants';

const proInitialState = {
  showGoProPopup: false,
  showProWelcomeOverlay: false,
  currentPlan: null,
  hasConsumedFreeTrial: null,
  canManageBilling: false,
  subscriptionLoading: false,
};

export function proReducer(state = proInitialState, action) {
  switch (action.type) {
    case actionTypes.pro.setShowGoProPopup:
      return {
        ...state,
        showGoProPopup: action.payload,
      };
    case actionTypes.pro.setShowProWelcomeOverlay:
      return {
        ...state,
        showProWelcomeOverlay: action.payload,
      };
    case actionTypes.pro.setSubscriptionLoading:
      return {
        ...state,
        subscriptionLoading: action.payload,
      };
    case actionTypes.pro.setSubscriptionInfo:
      return {
        ...state,
        currentPlan: action.payload.currentPlan,
        hasConsumedFreeTrial: action.payload.hasConsumedFreeTrial,
        canManageBilling: action.payload.canManageBilling,
        subscriptionLoading: false,
      };
    default:
      return state;
  }
}
